import api, { handleApiResponse } from './api';
import { ApiResponse, Sale, SaleHistory } from '../types';

// Tipos para la creación de ventas
export interface CreateSaleFunctionalUnit {
  functionalUnitId: number;
  priceAtSale: number;
}

// Interface for payment method creation (sent to backend)
export interface CreateSalePaymentMethod {
  currency: 'ARS' | 'USD';
  paymentType: 'EFECTIVO' | 'FINANCIADO';
  accountingType: 'A' | 'B';
  description: string;
  amount: number;
  exchangeRate: number;
  paymentDate?: string;
  iva?: number;
  financingType?: string;
  firstInstallmentDate?: string;
  installments?: number;
  indexationType?: string;
  indexBaseDate?: string;
  moraRate?: number;
  moraFrequency?: string;
}

// Interface for creating a sale (sent to backend)
export interface CreateSaleRequest {
  clientId: number;
  functionalUnits: CreateSaleFunctionalUnit[];
  deliveryDate: string;
  observations?: string;
  currency: string;
  exchangeRate: number;
  total: number;
  paymentMethods: CreateSalePaymentMethod[];
}

// Interface for payment method UI state (with string amounts and id for local management)
export interface PaymentMethod {
  id: string;
  currency: 'ARS' | 'USD';
  paymentType: 'cash' | 'financing';
  accountingType: 'A' | 'B';
  description: string;
  amount: string; // String for UI formatting
  iva: string; // String for UI formatting
  exchangeRate: string; // String for UI formatting
  paymentDate?: string;
  financingType?: string;
  firstInstallmentDate?: string;
  installments?: number;
  updateIndex?: string; // Local field name (maps to indexationType)
  indexBaseDate?: string;
  moraRate?: string;     // % de mora (ej: "2.5")
  moraFrequency?: string; // DAILY | MONTHLY | ANNUAL
}

export const salesService = {
  /**
   * Crear una nueva venta
   * @param request - Datos de la venta a crear
   * @returns Promise con la venta creada
   */
  async createSale(request: CreateSaleRequest): Promise<Sale> {
    const response = await api.post<ApiResponse<Sale>>('/sales', request);
    return handleApiResponse(response);
  },

  /**
   * Obtener el historial de todas las ventas
   * @returns Promise con el array de ventas
   */
  async getAllSales(): Promise<SaleHistory[]> {
    const response = await api.get<ApiResponse<SaleHistory[]>>('/sales');
    return handleApiResponse(response);
  },

  /**
   * Cancelar una venta (solo si no tiene cobranzas realizadas)
   */
  async cancelSale(id: number): Promise<void> {
    await api.delete(`/sales/${id}`);
  },
};

export default salesService;
